/* eslint-disable react-hooks/exhaustive-deps */
import { message, Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { IUseExternalContract } from "./IUseExternalContract";
import { ExternalContractData, ExternalInvestorData, InvestorErrorsDTO, PlacementAgentValues } from "../../Models";

import { emptyExternalContractData } from "../../Assets/Data/EmptyValues";

const useExternalContract = ({
  translations,
  templatesAPI,
  contractAPI,
  userIdInstitution,
  institutionAPI
}: IUseExternalContract) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [contractErrors, setContractErrors] = useState<any>({
    vehicleId: false,
    commitment: false,
    template: false,
    idPersonType: false,
    emailAddress: false,
    emailSubject: false,
    emailBody: false,
	fillerName: false,
	fillerLastName: false
  });
  const [investorsData, setInvestorsData] = useState<ExternalInvestorData[]>([
    {
      name: "",
      lastName: "",
    },
  ]);
  const [contractData, setContractData] = useState<ExternalContractData>(emptyExternalContractData);
  const [templateList, setTemplateList] = useState<any>([]);
  const [investorsErrors, setInvestorsErrors] = useState<any[]>([
    {
      name: false,
      lastName: false,
    },
  ]);
  const [placementAgentData, setPlacementAgentData] = useState<PlacementAgentValues[]>([])

  useEffect(() => {
    templateExists();
  }, [
    contractData.idLanguage,
    contractData.idPersonType,
    contractData.vehicleId,
  ]);

  useEffect(() => {
    getAllTemplates();
  }, []);

  useEffect(() => {
	if(!userIdInstitution && !placementAgentData) return;
    getInstitutionData(userIdInstitution);
  }, [userIdInstitution]);

  const navigate = useNavigate();

  const getInstitutionData = async (idInstitution: number) => {
	await institutionAPI
	  .getVehiclesByInstitution(idInstitution)
	  .then((res: any) => {
					if (res.success) {
		  setPlacementAgentData(res.data);
		}
	  })
	  .catch((res: any) => {
		message.error("Error with institution");
	  });
  }

  const getAllTemplates = async () => {
    await templatesAPI
      .getTemplateList(false)
      .then((res: any) => {
        if (res.success) {
          setTemplateList(res.data);
        }
      })
      .catch((res: any) => {
        message.error("Error with templates");
      });
  };
  const onChangeData = (value: any, field: any) => {
    setContractData((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));
    setContractErrors((prevState: any) => ({
      ...prevState,
      [field]: false,
    }));

    // if numSignatories changes, add or remove investorsName
    if (field === "numSignatories") {
      const newInvestorsName = [...investorsData];
      if (value > investorsData.length) {
        const difference = value - investorsData.length;
        for (let i = 0; i < difference; i++) {
          newInvestorsName.push({
			name: "",
			lastName: "",
		  });
        }
      } else if (value < investorsData.length) {
        newInvestorsName.splice(value);
      }
      setInvestorsData(newInvestorsName);

      setInvestorsErrors((prevState: any[]) => {
        const updatedErrors = [...prevState];
        if (value > investorsData.length) {
          for (let i = 0; i < value - investorsData.length; i++) {
            updatedErrors.push({ name: false, lastName: false });
          }
        } else if (value < investorsData.length) {
          updatedErrors.splice(value);
        }
        return updatedErrors;
      });
    }
  };

  const postExternalContract = async (data: any) => {
    await contractAPI
      .saveExternalContract(data)
      .then(async (res: any) => {
        if (res.success && res.data) {
          notification.success({
			message: translations.datosGuardados,
			description: translations.emailEnviado,
			duration: 10,
		  });
		  navigate("/Overview");
        } else {
          message.error(translations.messageError);
        }
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
        message.error(translations.messageError);
      });
  };

  const sendEmailConfirm = () => {
    if (!validateData()) return;

    Modal.confirm({
      title: translations.confirm,
      content: translations.confirmEmail,
      okText: translations.enviar,
      cancelText: translations.cancel,
      centered: true,
      onOk: async () => {
        setLoading(true);
        await postExternalContract({
          IdInstitutionRef: userIdInstitution,
          IdVehicle: contractData.vehicleId,
          IdLanguage: contractData.idLanguage,
          IdPersonType: contractData.idPersonType,
          Commitment: contractData.commitment,
          EmailAddress: contractData.emailAddress,
          EmailSubject: contractData.emailSubject,
          EmailBody: contractData.emailBody,
		  FillerName: contractData.fillerName,
		  FillerLastName: contractData.fillerLastName,
		  Investors: investorsData,
		  NumSignatories: contractData.numSignatories,
        }).then(() => {
          setLoading(false);
        });
      },
    });
  };

  const getVehicleName = () => {
    const vehicle = placementAgentData?.find(
      (x: PlacementAgentValues) => x.vehicleId === contractData.vehicleId
    );
    return vehicle ? vehicle.vehicleLegalName : "";
  };
  const isAllowedAmount = async (amount: number) => {
    if (amount) {
      await contractAPI
        .checkAllowedAmount(
          contractData.vehicleId,
          userIdInstitution,
          amount
        )
        .then((isAllowed: boolean) => {
          setContractErrors((prevState: any) => ({
            ...prevState,
            commitment: !isAllowed,
          }));
          if (isAllowed === false) {
            notification.error({
              message: `${getVehicleName()} ${
                translations.limiteExcedidoTitulo
              }`,
              description: translations.limiteExcedido,
              duration: 10,
            });
          }
        })
        .catch(() => {
          message.error(translations.messageError);
        });
    } else {
      setContractErrors((prevState: any) => ({
        ...prevState,
        amountError: false,
      }));
    }
  };

  const validateData = () => {
    let isOK = true;
    Object.entries(contractData).forEach(([key, value]) => {
      if (!value) {
        setContractErrors((prevState: any) => ({
          ...prevState,
          [key]: true,
        }));
        isOK = false;
      }
    });

    return isOK;
  };

  const handleChangeData = (index: number) => (e: any) => {
    const { name, value } = e.target;

    if (name === "documentType") {
      const updatedElements = investorsData.map((element: any, i: number) =>
        i === index
          ? { ...element, [name]: value, dni: "", nif: "", residenceCard: "" }
          : element
      );
      setInvestorsData(updatedElements);
    } else {
      const updatedElements = investorsData.map((element: any, i: number) =>
        i === index ? { ...element, [name]: value } : element
      );
      setInvestorsData(updatedElements);
    }

    setInvestorsErrors((prevState: InvestorErrorsDTO[]) => {
      const updatedErrors = [...prevState];
      updatedErrors[index || 0] = {
        ...updatedErrors[index || 0],
        [name]: false,
      };
      return updatedErrors;
    });
    setInvestorsData((prevState: ExternalInvestorData[]) => {
      const updatedInvestors = [...prevState];
      updatedInvestors[index] = {
        ...updatedInvestors[index],
        [name]: value,
      };
      return updatedInvestors;
    });
  };

  const templateExists = () => {
    const errorsCopy = { ...contractErrors };
    let exists = false;

    const { idPersonType, vehicleId, idLanguage } = contractData;
    if (templateList.length === 0) return false;
    if (!idPersonType || !vehicleId || !idLanguage) return false;
    const template = templateList.find(
      (x: any) =>
        x.idPersonType === idPersonType &&
        x.idVehicle === vehicleId &&
        x.idLanguage === idLanguage
    );

    if (!template) {
      errorsCopy.noTemplate = true;
      exists = false;
    } else {
      errorsCopy.noTemplate = false;
      exists = true;
    }
    setContractErrors(errorsCopy);
    return exists;
  };

  return {
    loading,
    contractErrors,
    contractData,
    onChangeData,
    sendEmailConfirm,
    isAllowedAmount,
    handleChangeData,
    investorsData,
    investorsErrors,
	placementAgentData
  };
};

export default useExternalContract;
